import { AudioService } from "@fidget/common/services/audioService";
import CallAudio from "../assets/call.mp3";
import MessageLongAudio from "../assets/message_long.mp3";
import MessageShortAudio from "../assets/message_short.mp3";

export interface RingtoneService {
  playMessageSoundForActiveTab(): void;

  playMessageSoundForInactiveTab(): void;

  playCallSound(): void;

  stopCallSound(): void;

  init(): void;
}
export class DefaultRingtoneService extends AudioService implements RingtoneService {
  constructor() {
    super([
      { name: "message-long", content: MessageLongAudio },
      { name: "message-short", content: MessageShortAudio },
      { name: "call", content: CallAudio, loop: true }
    ]);
  }

  playMessageSoundForActiveTab() {
    this.play("message-short");
  }

  playMessageSoundForInactiveTab() {
    this.play("message-long");
  }

  playCallSound() {
    this.play("call");
  }

  stopCallSound() {
    this.stop("call");
  }
}
